import { sdkIdentityFromPackage } from "@highnoteplatform/types";

import { name, version } from "../package.json";

const { CHECKOUT_IFRAME_PORT = 3014 } = process.env;

const identity = sdkIdentityFromPackage({ name, version });
export const packageName: string = identity.name;
export const packageVersion: string = identity.version;

export const iframeOrigin =
  process.env.NODE_ENV === "production"
    ? "https://cdn.highnote.com"
    : `http://localhost:${CHECKOUT_IFRAME_PORT}`;

// NOTE: the production iframe bundle is fetched from a fixed CDN path segment
// ("checkout") that MUST match the deploy pipeline's hardcoded app name
// (publish-release.yml `matrix.app`) — keep it a literal, never derived, so a
// package.json rename can't point the fetch at an undeployed path. The version
// segment keys the bundle to THIS package's version: a release that changes
// checkout-iframes without bumping @highnoteplatform/checkout would overwrite an
// already-deployed bundle in place — always version them together. The telemetry
// sdkName (handshake.ts) IS derived from the package name via packageName;
// handshake.test.ts asserts sdkName === "checkout", which pins packageName to
// this same literal so the telemetry label and CDN segment cannot silently
// desync.
const iframePath =
  process.env.NODE_ENV === "production"
    ? `checkout/${packageVersion}/index.html`
    : "index.html";

export const iframeUri = `${iframeOrigin}/${iframePath}`;
